import { getFileUrlPresigned } from '../services/fileService'

export const useUrlPresigned = async (url: string) => {
  if (!url) return

  if (url.includes('http')) {
    window.open(url, '_blank')
    return
  }

  const fileUrl = await getFileUrlPresigned(url)
  return fileUrl
}
